"use client";

import { useState } from "react";
import Icon from "@/components/ui/AppIcon";

const faqs = [
  {
    q: "Is there a minimum order volume?",
    a: "No. Helium operates with zero MOQ. You can start with 10 orders a month and scale to 10,000 without renegotiating your contract. We grow with you.",
  },
  {
    q: "How does pricing work exactly?",
    a: "Pricing is custom-quoted based on your monthly order volume, average product weight and dimensions, shipping destinations, and services required. We don't publish fixed rates because your exact mix determines your cost — and we want to give you an accurate number, not a misleading starting price.",
  },
  {
    q: "Are there any hidden fees or setup costs?",
    a: "No setup fees and no hidden charges. You pay for storage (per CBM per month), fulfillment (per order), and shipping (per shipment). We itemize everything on your monthly invoice.",
  },
  {
    q: "Do you offer long-term contracts?",
    a: "We work on rolling monthly agreements. No 12-month lock-ins. If Helium isn't working for you, you can transition out with 30 days notice and we'll help coordinate the transfer.",
  },
  {
    q: "How quickly can I get started?",
    a: "Most brands are fully onboarded within 48 hours of signing. We send you our platform credentials, integration guide, and your dedicated account manager's contact on day one.",
  },
  {
    q: "What happens if my volume spikes during Q4?",
    a: "Our Shenzhen warehouse has 40,000 sqft of capacity with overflow agreements in place. We've handled 4x normal volume surges for clients during Black Friday and Q4 peaks without service degradation.",
  },
];

export default function PricingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-helium-surface/40">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="section-label mb-4 inline-flex">Common Questions</span>
          <h2
            className="font-heading font-extrabold text-gray-900"
            style={{ fontSize: "clamp(28px, 3.5vw, 40px)", letterSpacing: "-0.02em" }}
          >
            Pricing FAQ
          </h2>
        </div>

        <div className="space-y-0 bg-white rounded-3xl border border-helium-border overflow-hidden">
          {faqs?.map((faq, i) => (
            <div key={faq?.q} className="faq-item">
              <button
                className="w-full flex items-center justify-between gap-4 px-8 py-6 text-left hover:bg-helium-surface/40 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                aria-expanded={openIndex === i}
              >
                <span className="font-semibold font-heading text-gray-900 text-base">{faq?.q}</span>
                <Icon
                  name="ChevronDownIcon"
                  size={18}
                  className={`text-helium-400 shrink-0 transition-transform duration-300 ${openIndex === i ? "rotate-180" : ""}`}
                />
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === i ? "max-h-48" : "max-h-0"
                }`}
              >
                <p className="px-8 pb-6 text-gray-500 text-sm leading-relaxed">{faq?.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}